module.exports = __webpack_public_path__ + "static/media/linkedin.1bcec619.svg";